import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

// Layout
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer.js";

// Pages
import HomePage from "@/pages/HomePage";
import ERPProgramsPage from "@/pages/ERPProgramsPage";
import ERPDetailPage from "@/pages/ERPDetailPage";
import IFSDetailPage from "@/pages/IFSDetailPage";
import OdooDetailPage from "@/pages/OdooDetailPage";
import OracleDetailPage from "@/pages/OracleDetailPage";
import NetSuiteDetailPage from "@/pages/NetSuiteDetailPage";
import InforDetailPage from "@/pages/InforDetailPage";
import CloudPage from "@/pages/CloudPage";
import AIPage from "@/pages/AIPage";
import AI900ExamPrepPage from "@/pages/AI900ExamPrepPage";
import AI102ExamPrepPage from "@/pages/AI102ExamPrepPage";
import AZ900ExamPrepPage from "@/pages/AZ900ExamPrepPage";
import DP100ExamPrepPage from "@/pages/DP100ExamPrepPage";
import AB900ExamPrepPage from "@/pages/AB900ExamPrepPage";
import SC300ExamPrepPage from "@/pages/SC300ExamPrepPage";
import NCAGENLExamPrepPage from "@/pages/NCAGENLExamPrepPage";
import AZ104ExamPrepPage from "@/pages/AZ104ExamPrepPage";
import SC900ExamPrepPage from "@/pages/SC900ExamPrepPage";
import GoogleAIEssentialsExamPrepPage from "@/pages/GoogleAIEssentialsExamPrepPage";
import MicrosoftTrackPage from "@/pages/MicrosoftTrackPage";
import GoogleTrackPage from "@/pages/GoogleTrackPage";
import AWSTrackPage from "@/pages/AWSTrackPage";
import TeamEnrollmentPage from "@/pages/TeamEnrollmentPage";
import MyLibraryPage from "@/pages/MyLibraryPage";
import BusinessSoftwarePage from "@/pages/BusinessSoftwarePage";
import TrainingModelPage from "@/pages/TrainingModelPage";
import CertificationPage from "@/pages/CertificationPage";
import PricingPage from "@/pages/PricingPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import WebinarPage from "@/pages/WebinarPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Public Routes with Layout */}
          <Route path="/" element={<><Header /><HomePage /><Footer /></>} />
          <Route path="/programs" element={<><Header /><ERPProgramsPage /><Footer /></>} />
          <Route path="/programs/ifs" element={<><Header /><IFSDetailPage /><Footer /></>} />
          <Route path="/programs/odoo" element={<><Header /><OdooDetailPage /><Footer /></>} />
          <Route path="/programs/oracle" element={<><Header /><OracleDetailPage /><Footer /></>} />
          <Route path="/programs/netsuite" element={<><Header /><NetSuiteDetailPage /><Footer /></>} />
          <Route path="/programs/infor" element={<><Header /><InforDetailPage /><Footer /></>} />
          <Route path="/programs/:erp" element={<><Header /><ERPDetailPage /><Footer /></>} />
          <Route path="/cloud" element={<><Header /><CloudPage /><Footer /></>} />
          <Route path="/ai" element={<><Header /><AIPage /><Footer /></>} />
          <Route path="/ai-900-exam-prep" element={<><Header /><AI900ExamPrepPage /><Footer /></>} />
          <Route path="/ai-102-exam-prep" element={<><Header /><AI102ExamPrepPage /><Footer /></>} />
          <Route path="/az-900-exam-prep" element={<><Header /><AZ900ExamPrepPage /><Footer /></>} />
          <Route path="/dp-100-exam-prep" element={<><Header /><DP100ExamPrepPage /><Footer /></>} />
          <Route path="/ab-900-exam-prep" element={<><Header /><AB900ExamPrepPage /><Footer /></>} />
          <Route path="/sc-300-exam-prep" element={<><Header /><SC300ExamPrepPage /><Footer /></>} />
          <Route path="/nca-genl-exam-prep" element={<><Header /><NCAGENLExamPrepPage /><Footer /></>} />
          <Route path="/az-104-exam-prep" element={<><Header /><AZ104ExamPrepPage /><Footer /></>} />
          <Route path="/sc-900-exam-prep" element={<><Header /><SC900ExamPrepPage /><Footer /></>} />
          <Route path="/google-ai-essentials-exam-prep" element={<><Header /><GoogleAIEssentialsExamPrepPage /><Footer /></>} />
          <Route path="/microsoft-track" element={<><Header /><MicrosoftTrackPage /><Footer /></>} />
          <Route path="/google-track" element={<><Header /><GoogleTrackPage /><Footer /></>} />
          <Route path="/aws-track" element={<><Header /><AWSTrackPage /><Footer /></>} />
          <Route path="/team-enrollment" element={<><Header /><TeamEnrollmentPage /><Footer /></>} />
          <Route path="/my-library" element={<><Header /><MyLibraryPage /><Footer /></>} />
          <Route path="/business-software" element={<><Header /><BusinessSoftwarePage /><Footer /></>} />
          <Route path="/training-model" element={<><Header /><TrainingModelPage /><Footer /></>} />
          <Route path="/certification" element={<><Header /><CertificationPage /><Footer /></>} />
          <Route path="/pricing" element={<><Header /><PricingPage /><Footer /></>} />
          <Route path="/about" element={<><Header /><AboutPage /><Footer /></>} />
          <Route path="/contact" element={<><Header /><ContactPage /><Footer /></>} />
          <Route path="/webinar" element={<><Header /><WebinarPage /><Footer /></>} />
          <Route path="/payment/success" element={<><Header /><PaymentSuccessPage /><Footer /></>} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
